import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f3448e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-4 f-roboto fw-light" }, "Review", -1))
const _hoisted_2 = { class: "send-to-partner-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small-info-text" }, "Review the questions below. Complete questions that require updates. When done, click 'Save'.", -1))
const _hoisted_4 = { class: "d-flex justify-content-end" }
const _hoisted_5 = {
  class: "d-flex flex-column align-items-center",
  style: {"width":"1015px","margin":"0 auto"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Enter access password", -1))
const _hoisted_9 = {
  key: 0,
  style: {"color":"red"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_review_sent_request_question_answer = _resolveComponent("review-sent-request-question-answer")!
  const _component_RotateLoader = _resolveComponent("RotateLoader")!
  const _component_white_box_main = _resolveComponent("white-box-main")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_the_modal = _resolveComponent("the-modal")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, {
    "no-sidebar": true,
    "no-search": true
  }, {
    "header-left": _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      (!_ctx.enterPasswordModal.isOpen.value)
        ? (_openBlock(), _createBlock(_component_white_box_main, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_BaseButton, {
                    class: "mb-20 save-button",
                    onClick: _ctx.saveResponse
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Save")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (!_ctx.isSaving)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, ix) => {
                          return (_openBlock(), _createBlock(_component_review_sent_request_question_answer, {
                            key: question.id,
                            ix: ix,
                            question: question,
                            "is-active": _ctx.isQuestionActive(question.id),
                            error: '',
                            count: ix,
                            onHandleValueUpdate: _ctx.handleValueUpdate
                          }, null, 8, ["ix", "question", "is-active", "count", "onHandleValueUpdate"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isSaving)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_RotateLoader),
                        _createTextVNode(" Saving ...")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.enterPasswordModal.isOpen.value,
        onOnCancel: _ctx.enterPasswordModal.close,
        onOnConfirm: _ctx.enterPasswordModal.close
      }, {
        content: _withCtx(() => [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
            class: "input-field",
            placeholder: "Enter password",
            type: "password"
          }, null, 512), [
            [_vModelText, _ctx.password]
          ]),
          (_ctx.modalError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.modalError), 1))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, { onClick: _ctx.handleModalEnter }, {
            default: _withCtx(() => [
              _createTextVNode("Ok")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["is-visible", "onOnCancel", "onOnConfirm"])
    ]),
    _: 1
  }))
}